import React from "react";
import axios from "axios";
import moment from "jalali-moment";
import {Image, Row} from "react-bootstrap";
import * as jalaliMoment from "jalali-moment";
import {Loading} from "./partials/Global/Loading";
import {withRouter} from "react-router-dom";
import {CopyRight} from "./partials/Global/CopyRight";
import {FooterBody} from "./partials/Global/FooterBody";
import {Navigation} from "./partials/Global/Navigation";
import {DottedLoading} from "./partials/Global/DottedLoading";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";
import Pagination from "./partials/Global/Pagination";



class News extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            paginate: [],
            news: {}
        };

        // Set current page from url or 1
        const query = new URLSearchParams(this.props.location.search);
        this.state.paginate.currentPage = query.get("page") || 1;
    }

    async componentDidMount() {
        await this.getNews();
    }

    async componentDidUpdate(prevProps, prevState) {
        const query = new URLSearchParams(this.props.history.location.search);

        if (this.state.paginate.currentPage !== prevState.paginate.currentPage) {
            query.set("page", this.state.paginate.currentPage);
            this.props.history.push(
                decodeURIComponent(this.props.location.pathname) +
                "?" +
                decodeURIComponent(query.toString())
            );

            await this.getNews();
        }
    }

    getNews = async () => {
        this.setState({isLoading: true});
        const result = await axios
            .post(
                process.env.REACT_APP_API_URL +
                process.env.REACT_APP_GET_NEWS_PATH +
                this.state.paginate.currentPage +
                '/12.json',
                {
                    apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN
                }
            );

        this.setState({
            news: result.data.result.data.news,
            paginate: result.data.result.data.paginate,
            isLoading: false
        });

        return result;
    };

    updatePaginate = currentPage => {
        const paginate = {...this.state.paginate};
        paginate.currentPage = currentPage;
        this.setState({paginate});
    };

    truncate = (str, maxlen = 10) => {
        return str.length > maxlen ? str.substring(0, maxlen) + "..." : str;
    };

    renderNews = key => {
        let item = this.state.news[key];

        let item_image = (item.attachments && !item.attachments.includes("default.jpg")) ?
            item.attachments :
            process.env.REACT_APP_BASE_URL + "/images/default/news.jpg";

        let news_date = jalaliMoment(item.modified, 'YYYY/M/D')
            .locale('fa')
            .format('jD jMMMM YYYY');

        const two_weeks_ago = moment().subtract(14, 'days')
            .locale('fa')
            .format('YYYY/MM/DD');

        const modified = moment(item.modified, 'YYYY/MM/DD')
            .locale('fa')
            .format('YYYY/MM/DD');

        let is_new = Date.parse(two_weeks_ago) < Date.parse(modified);

        return (
            <div className="col-lg-4 col-md-6">
                <div className="item mb-50">
                    <div className="img">
                        <div className='news-wrapper'>
                            <Image src={item_image} alt=""/>
                        </div>
                        <div className="date">
                            <a href={"/news-detail/" + item.slug}>{news_date} {is_new? <span> | <span className='alert-danger'>جدید</span></span> : ''}</a>
                        </div>
                    </div>
                    <div className="cont mt-30">
                        <h6>
                            <a href={"/news-detail/" + item.slug}>{(item.title)}</a>
                        </h6>
                        <a href={"/news-detail/" + item.slug} className="mt-20 ls1 sub-title">
                            مشاهده جزئیات خبر
                            <i className="ml-5">
                                <svg className="mirror" width="18" height="18" viewBox="0 0 18 18"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M13.922 4.5V11.8125C13.922 11.9244 13.8776 12.0317 13.7985 12.1108C13.7193 12.1899 13.612 12.2344 13.5002 12.2344C13.3883 12.2344 13.281 12.1899 13.2018 12.1108C13.1227 12.0317 13.0783 11.9244 13.0783 11.8125V5.51953L4.79547 13.7953C4.71715 13.8736 4.61092 13.9176 4.50015 13.9176C4.38939 13.9176 4.28316 13.8736 4.20484 13.7953C4.12652 13.717 4.08252 13.6108 4.08252 13.5C4.08252 13.3892 4.12652 13.283 4.20484 13.2047L12.4806 4.92188H6.18765C6.07577 4.92188 5.96846 4.87743 5.88934 4.79831C5.81023 4.71919 5.76578 4.61189 5.76578 4.5C5.76578 4.38811 5.81023 4.28081 5.88934 4.20169C5.96846 4.12257 6.07577 4.07813 6.18765 4.07812H13.5002C13.612 4.07813 13.7193 4.12257 13.7985 4.20169C13.8776 4.28081 13.922 4.38811 13.922 4.5Z"
                                        fill="currentColor"> </path>
                                </svg>
                            </i>
                        </a>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main>
                    <header className="page-header">
                        <div className="container mt-80">
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="caption">
                                        <div className="sub-title">
                                            <a href={"/"}><span>خانه</span></a>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>اخبار</span>
                                        </div>
                                        <h1 className="fz-70">آخرین اخبار</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <section className="blog-modern section-ptb pb-0 sub-bg">
                        <div className="container">
                            <div className="row">
                                {!this.state.isLoading
                                    ? Object.keys(this.state.news)
                                        .map(this.renderNews)
                                    : <div className='mt-30 mb-80 text-center' style={{marginRight: '49%'}}><DottedLoading/></div>}
                            </div>
                        </div>
                    </section>
                    {!this.state.isLoading && this.state.news.length >= 1 &&
                    <section className="main-shop pt-0 pb-70 sub-bg">
                        <div className="container">
                            <div className="row md-marg">
                                <div className="col-lg-12">
                                    <div className={"shop-products"}>
                                        <Row>
                                            <div className="pagination d-flex justify-content-center mt-30">
                                                <Pagination
                                                    paginate={this.state.paginate}
                                                    updatePaginate={this.updatePaginate}
                                                />
                                            </div>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>}
                </main>
                <footer className="pt-80">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </>
        );
    }
}

export default withRouter(News);
